import Axios, { AxiosInstance } from "axios";
import { plainToClass } from "class-transformer";
import { singleton } from "tsyringe";
import {
	AdvisorInfo,
	GenerateOtp,
	SignUpResponse,
	UserSignUP,
} from "../App/ClientOnboarding/model/UserSignUpClass";
import { TransactionsResponse } from "../App/TransactionsApproval/Models/ApiModels";

@singleton()
export default class PartnerApis {
	instance: AxiosInstance = Axios.create({
		baseURL: process.env.REACT_APP_APPSERVER_URL,
	});
	constructor() {
		this.instance.interceptors.request.use(
			(config) => {
				return config;
			},
			(err) => Promise.reject(err)
		);

		this.instance.interceptors.response.use(
			(e) => e,
			(err) => {
				if (err.response.data.userMsg) err.message = err.response.data.userMsg;
				return Promise.reject(err);
			}
		);
	}

	async getAdvisorInfo(advisorId: string): Promise<AdvisorInfo> {
		const responseFromGetAdvisorInfo = await this.instance.request({
			method: "POST",
			url: "/auth/getAdvisorInfo",
			data: {
				advisorId,
			},
		});

		return plainToClass(AdvisorInfo, responseFromGetAdvisorInfo.data);
	}

	async generateOtp({ phoneNumber, email }: { phoneNumber: string, email?: string }): Promise<any> {
		const responseFromGenerateOtp = await this.instance.request({
			method: "POST",
			url: "/auth/generateSignupOTP",
			data: {
				phoneNumber,
				email
			},
		});

		return plainToClass(GenerateOtp, responseFromGenerateOtp.data);
	}

	async signUp(req: UserSignUP): Promise<SignUpResponse> {
		const res = await this.instance.request({
			method: "POST",
			url: "/auth/signup",
			data: req,
		});

		return plainToClass(SignUpResponse, res.data);
	}
	async getTransactions(token: string): Promise<TransactionsResponse> {
		var response = await this.instance.request({
			method: 'GET',
			url: '/mweb/transactions',
			headers: {
				Authorization: "Bearer " + token
			}
		});

		return plainToClass(TransactionsResponse, response.data);
	}
	async selfDecarationLoginOtpGeneration(data:{username:string}) {
		
		var response =  await this.instance.request({
            method: "post",
			url: "/mweb/onlinedsc/loginOTP",
			data
		})
		return response.data;
	}
	async selfDeclarationLogin(data: { username: string, otp: string })
	{
		var response =  await this.instance.request({
            method: "post",
			url: "/mweb/onlinedsc/login",
			data
		})
		return response.data;
	}

	async approveTransactions(path: string, checkedItems: string[]): Promise<any> {
		var response = await this.instance.request({
			method: 'POST',
			url: path,
			data: JSON.stringify(checkedItems),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		});
		console.log('response from api', response);
		return response;
	}

	async approveTransactionsWithOtp(path: string, txnIds: string[], otp: string): Promise<void> {
		await this.instance.request({
			method: 'POST',
			url: path,
			data: {
				txnIds,
				otp
			},
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		});
	}
}
